var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLelyNoMilkDropList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177 100c0-27 34-49 77-49s78 22 78 49c0 26-35 48-78 48s-77-22-77-48Z",
    fill: "#CF1322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m294 129-10-4v-22l-11-23 6-3 8 15 5-21 9-4-7 33v29Zm-17-7-19-9V86l9-4v27l10 4v9Zm-27-29-7-2v5l7 1v5l-7 1v5l7-2v7l-14 6V80l14 6v7Zm-19 28-22 10V68l10 5v44l12-4v8Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m187 253 23-35v-6c-4 0-8-4-8-8v-34c0-4 4-8 8-8h85c5 0 9 4 9 8v34c0 4-4 8-9 8v6l24 35c7 10 10 21 10 33v136c0 14-11 25-25 25H202c-14 0-25-11-25-25V286c0-12 3-23 10-33Zm100-74h-68v16h68v-16Zm-93 111c5 3 14 6 25 6 16 0 30-8 30-8s17-9 38-9c10 0 19 2 25 4 0-7-3-14-7-20l-25-38-2-5v-8h-51v8l-1 5-25 38c-5 7-7 15-7 23v4Zm104 61a7 7 0 0 0-11-10l-37 40c-2 2-5 2-7 0l-23-19a7 7 0 0 0-9 11l23 19c8 7 19 6 26-1l38-40Z",
    fill: "#CF1322"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLelyNoMilkDropList);
export default __webpack_public_path__ + "static/media/lely-no-milk-drop-list.c88131dc.svg";
export { ForwardRef as ReactComponent };